import React, { Component } from 'react';

import Accordion from './Accordion';
import Tabs from './Tabs';

class AccordionFamily extends Component {
  render() {
    const {
      lesson: { variant }
    } = this.props;
    console.log('inner variant' + variant);
    switch (variant) {
      case 'accordion':
        return <Accordion {...this.props} />;
      case 'tabs':
        return <Tabs {...this.props} />;
      default:
        return null;
    }
  }
}

export default AccordionFamily;
